import React from "react";
const NftPrice = () => {
    return (
        <>
            <div className="_nft_content_card_wrap _nft_content_price_wrap">
                <div className="_nft_content_card_inner">
                    <h4 className="_nft_content_card_title">Price</h4>
                    <div className="_nft_content_card_crypto_wrap">
                        <span className="_nft_content_card_crypto_ic">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none"
                                viewBox="0 0 20 20">
                                <path fill="#6B8CEF" fill-rule="evenodd"
                                    d="M9.844.842V7.69L4.778 9.955l5.066-2.263v5.945l-5.786-3.36L9.844.841Zm.002 0 5.787 9.434-5.787 3.361V7.692l5.066 2.263L9.846 7.69V.842Zm-.002 13.873v4.653l-5.79-8.013 5.79 3.36Zm.002 4.653v-4.654l5.787-3.36-5.787 8.014Z"
                                    clip-rule="evenodd" />
                            </svg>
                        </span>
                        <p className="_nft_content_card_crypto_txt">
                            3.52 ETH ($9118.1 USD)
                        </p>
                    </div>
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                            <button className="_nft_content_card_crypto_btn w-100">
                                Buy Now
                            </button>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                            <button
                                className="_nft_content_card_crypto_btn _nft_content_card_crypto_btn2 w-100">
                                Offer
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default NftPrice;